import { useQuery, useQueryClient } from "@tanstack/react-query";
import { creditsApi, CreditContext } from "./api";
import { ApiAuth } from "../../../lib/api";

const CREDIT_KEY = "patient-credit";

export function useCredit(auth: ApiAuth, ctx: CreditContext, enabled = true) {
  return useQuery({
    queryKey: [CREDIT_KEY, ctx.organizationId ?? null, ctx.locationId ?? null],
    queryFn: () => creditsApi.get(auth, ctx),
    enabled,
    staleTime: 30_000,
  });
}

export function useInvalidateCredit() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: [CREDIT_KEY] });
}
